import(/* webpackMode: "eager", webpackExports: ["MainLayout"] */ "E:\\Workstation\\Work\\develop\\code\\ethereum\\presale\\layerbrett\\layerbrett_frontend\\src\\components\\layout\\mainLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrivacyIndex"] */ "E:\\Workstation\\Work\\develop\\code\\ethereum\\presale\\layerbrett\\layerbrett_frontend\\src\\components\\privacy\\index.tsx");
